import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Dealing with Real Estate Agents</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    {
                      url: '/dealing-with-agents',
                      name: 'Dealing with agents',
                    },
                  ]}
                />
                <h2 className="lead text-center">Dealing With Agents</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <h4>What is an Agent</h4>
                    <p>
                      A Real Estate Agent is a person licensed to negotiate and transact the sale or lease of real
                      estate on behalf of the property owner. Real estate agents are trained, licensed professionals who
                      must follow the standards set out in the Code of Professional Conduct and Client Care. They must
                      also meet their obligations under the Real Estate Agents Act 2008
                    </p>
                    <hr />
                    <h4>Can they be trusted?</h4>
                    <p>
                      The key part here is that an agent is acting on the behalf of the owner. This means that if you
                      are buying a property, then to be safe you should take what they say with a grain of salt.{' '}
                    </p>
                    <p>
                      Now thats not to say that you can't trust them; for the most part you can as they are governed by
                      the <a href="https://www.rea.govt.nz/">Real Estate Authority</a>:{' '}
                      <strong>Real estate agents are duty-bound to answer honestly</strong> and the agent or seller is{' '}
                      <strong>required to tell you about any known problems with the property</strong> and must not
                      withhold any details.
                    </p>
                    <p>
                      A savvy buyer should make sure that they don’t get caught up in the excitement of the house, and
                      instead ask some hard questions rather than assuming the agent will offer the ‘dirt’ on the house
                      voluntarily.
                    </p>
                    <p>
                      Another “gotcha” is assuming that the agent knows all about the house they are selling. We found
                      that most of the time they only knew the most basic information about the house, and so it was up
                      to your own research to try to figure out things like “why is there a concrete pit under the
                      house”, or “What’s with the concrete slab in the middle of the lawn” (both real questions we had
                      about our new home).
                    </p>
                    <hr />
                    <h4>Some of the common questions you should ask are:</h4>
                    <ul>
                      <li>Dealing with Agents</li>
                      <li>Is there anything that you need to declare? </li>
                      <li>Why is the owner selling?</li>
                      <li>
                        What work has been done on the property? If so, when and by whom*? *be aware of any DIY work,
                        this can be a red flag. Often larger jobs (e.g. roofing) are done by professional firms and have
                        warranties that you’ll want to record.{' '}
                      </li>
                      <li>Are any urgent repairs needed?</li>
                      <li>Are there any changes coming to the area's zoning?</li>
                      <li>Does the house have an unusual past?</li>
                      <li>Are there any weathertightness issues?</li>
                      <li>Does the property have official consent for all buildings? </li>
                      <li>Are there any problems/concerns with the boundary?</li>
                      <li>Has it been used as a P lab?</li>
                      <li>Is there any mould/dryness issues?</li>
                      <li>Are there any community issues?</li>
                      <li>If it's an apartment – what are the body corporate rules?</li>
                    </ul>
                    <p>
                      The agent probably won't have the answers to all of these questions, but it doesn't hurt to ask.
                      And you’ll find that the more pro-active agents will offer to find the answers to your questions.
                    </p>
                    <p>
                      At the end of the day, remember that an agent’s job is to sell houses so they’re going to do
                      everything that they can to get you to put in your highest offer. That said, they’re still
                      obligated to be honest in their dealings with you.{' '}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DealingWithAgents.jsx